import { ListItemButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDeviceType } from "@hooks/useDeviceType";
import { useStyle } from "../style";
import { useNavigationLinks } from "../hook/useNavigationLinks";
import { NavigationLinkMobile } from "./NavigationLinkMobile";
import { keycloakUtils } from "itsf-ui-common";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";

interface IParams {
    onLoginLogout(): void;
    onNavigate?(): void;
}

export const NavigationMobile = (props: IParams) => {
    const { onLoginLogout, onNavigate } = props;
    const { t } = useTranslation("header");
    const { isDesktop } = useDeviceType();
    const { classes } = useStyle({ isDesktop });
    const links = useNavigationLinks();
    const isAuthenticated = keycloakUtils.isAuthenticated();

    return (
        <>
            {links.map((link) => {
                return <NavigationLinkMobile key={link.title} link={link} onNavigate={onNavigate} />;
            })}
            <ListItemButton
                className={classes.drawerMenuItem}
                component="div"
                disableGutters
                divider
                id={BUTTON_IDS.TOP_NAV[isAuthenticated ? "LOGOUT" : "LOGIN"]}
                role="button"
                tabIndex={0}
                onClick={onLoginLogout}
            >
                <Typography className={classes.drawerMenuItemText} variant="large">
                    {isAuthenticated ? t("logout") : t("login")}
                </Typography>
            </ListItemButton>
        </>
    );
};
